import { render } from "./ViewArticlePage.vue?vue&type=template&id=5d993dbc&ts=true"
import script from "./ViewArticlePage.vue?vue&type=script&lang=ts"
export * from "./ViewArticlePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__